import { PartnerTypeButtons } from 'legacy/lut/components/widgets/public/partner360/PartnerTypeButtons'
import { useMemo } from 'react'

import { TSegmentConrolCommon } from 'cng-common/components/segmentedControl/models'
import { ActualsValueTypes, DEFAULT_NETNDP_TYPES } from 'partner360/models/actualValueTypes'

interface IValueTypeSwitcherProps {
  valueType?: ActualsValueTypes
  valueTypes?: ActualsValueTypes[]
  onChangeValueType?: (value: ActualsValueTypes) => void
  translationKey?: string
  size?: TSegmentConrolCommon['size']
  background?: TSegmentConrolCommon['backgroudn']
}

export const ValueTypeSwitcher = ({
  valueType,
  valueTypes,
  onChangeValueType,
  translationKey,
  size,
  background,
}: IValueTypeSwitcherProps) => {
  const actualsValueTypes = useMemo(() => valueTypes || DEFAULT_NETNDP_TYPES, [valueTypes])

  if (!valueType || !onChangeValueType) {
    return null
  }

  return (
    <PartnerTypeButtons
      buttonCurrType={valueType}
      setButtonCurrType={(value) => onChangeValueType(value as ActualsValueTypes)}
      buttonTypes={actualsValueTypes}
      translationKey={translationKey || 'jbp-partner-actuals-value-type'}
      size={size}
      background={background}
    />
  )
}
